

export default class CommentService
{
    constructor(http) { 
        this.http = http        
    }

    async get(post_pk)
    {
        const endpoint = `/posts/${post_pk}/comments`
        const filters = JSON.stringify([
            {property: "active", value: true, stage: 1000},
            {property: "contents", value: post_pk, stage: 1001},
        ])
        const params = { filters }                        
        
        const {data} = await this.http.get(endpoint, { params })
        return data
    }

    async create(comment_data)
    {
        const endpoint = '/posts/comments'
        const {data} = await this.http.post(endpoint, comment_data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }            
        })
        return data
    }

    async delete(comment_id)
    {
        const endpoint = `/posts/${comment_id}/comments`
        return await this.http.delete(endpoint)        
    }
}